import React from "react";
import "./SecondReelSection.css";
import { useInView } from "../../../custom-hooks/useInView";

export const SecondReelSection = () => {
  const { ref: card1Ref, isVisible: showCard1 } = useInView();
  const { ref: card2Ref, isVisible: showCard2 } = useInView();
  return (
    <div className="secondSectionContainer">
      <div className="second-reel-content">
        {/* Tarjeta de ceremonia */}
        <div
          ref={card1Ref}
          className={`card-box fade-in-section ${
            showCard1 ? "is-visible" : ""
          }`}
        >
          <h2 className="card-title">CEREMONIA</h2>
          <div className="card-icon church-icon" />
          <p className="card-text">
            Parroquia Santa
            <br />
            Elena de la Cruz
          </p>
          <a
            className="map-button"
            href="https://www.google.com/maps/place/Parroquia+Santa+Elena+de+la+Cruz/@29.0864408,-110.9802804,16z/data=!3m1!4b1!4m6!3m5!1s0x86ce841409110b37:0x864cbf3be6bb78d9!8m2!3d29.0864408!4d-110.9802804!16s%2Fg%2F1td_z0tc?entry=ttu"
            target="_blank"
            rel="noopener noreferrer"
          >
            VER MAPA
          </a>
        </div>

        {/* Tarjeta de recepción */}
        <div
          ref={card2Ref}
          className={`card-box fade-in-section ${
            showCard2 ? "is-visible" : ""
          }`}
        >
          <h2 className="card-title">RECEPCIÓN</h2>
          <div className="card-icon-bouquet bouquet-icon" />
          <div className="card-icon-placeholder" />
          <p className="card-text">Hacienda del Parque</p>
          <a
            className="map-button"
            href="https://www.google.com/maps/place/HACIENDA+DEL+PARQUE/@29.0370848,-110.9061016,17z/data=!3m1!4b1!4m6!3m5!1s0x86ce85db5e7d35a3:0xd1a2d9215fef172a!8m2!3d29.0370848!4d-110.9061016!16s%2Fg%2F11v67s5ks3?entry=ttu"
            target="_blank"
            rel="noopener noreferrer"
          >
            VER MAPA
          </a>
        </div>
      </div>
    </div>
  );
};
